import gql from "graphql-tag";

export const getPlan = gql`
  query getPlan($entreprise: Int!) {
    getPlan(entreprise: $entreprise) {
      id
      categories {
        id
        profit
        name
        produits {
          id
          name
          isActive
          categorie {
            id
          }
        }
      }
    }
  }
`;
